"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _antd = require("antd");

var _templateObject, _templateObject2;

var Loader = function Loader(props) {
  var _props$text = props.text,
      text = _props$text === void 0 ? '' : _props$text,
      _props$height = props.height,
      height = _props$height === void 0 ? '100vh' : _props$height,
      _props$py = props.py,
      py = _props$py === void 0 ? 0 : _props$py;
  return /*#__PURE__*/_react.default.createElement(Container, {
    className: "jam-cms",
    height: height,
    py: py
  }, /*#__PURE__*/_react.default.createElement(Content, null, /*#__PURE__*/_react.default.createElement(_antd.Spin, {
    size: "large"
  }), text && /*#__PURE__*/_react.default.createElement("span", null, text)));
};

var Container = (0, _styledComponents.default)('div')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  height: ", ";\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-top: ", ";\n  padding-bottom: ", ";\n"])), function (_ref) {
  var height = _ref.height;
  return height;
}, function (_ref2) {
  var py = _ref2.py;
  return "".concat(py, "px");
}, function (_ref3) {
  var py = _ref3.py;
  return "".concat(py, "px");
});

var Content = _styledComponents.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  font-size: 12px;\n  text-transform: uppercase;\n  text-align: center;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,\n    'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',\n    'Noto Color Emoji';\n\n  span {\n    display: block;\n    margin-top: 20px;\n  }\n"])));

var _default = Loader;
exports.default = _default;